import {api} from '../components/Base/App';

export default {
    activateQuote(secretKey) {
        return api({
            method: 'get',
            url: `/quote/activate/${secretKey}`
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/Quote.js